import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/client/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/client/';

class ClientService {
  createClient(client) {
    return axios.post(API_URL , client);
  }

  updateClient(client) {
    return axios.put(API_URL , client);
  }

  updateClientByClient(client) {
    return axios.put(API_URL  + 'update/contact-details', client);
  }

  getClients() {
    return axios.get(API_URL + 'all');
  }

  getClientTypes() {
    return axios.get(API_URL + 'types');
  }

  getUsersOfClient(clientId, simplified = false) {
    return axios.get(API_URL + 'users/' + clientId, { params:{ simplified } });
  }

  getUsersOfSomeClient(simplified) {
    return axios.get(API_URL + 'users', { params:{ simplified } });
  }

  getLeaguesOfClient(clientId) {
    return axios.get(API_URL + 'leagues/' + clientId);
  }

  getSeasonsOfClient(clientId) {
    return axios.get(API_URL  + clientId + '/seasons');
  }

  getTinySeasonsOfClient(clientId) {
    return axios.get(API_URL  + clientId + '/seasons-tiny');
  }

  getTinySeasonsOfClientMatchDay6(clientId) {
    return axios.get(API_URL  + clientId + '/seasons-tiny-matchday-6');
  }

  getPhysicalSeasonsOfClient(clientId) {
    return axios.get(API_URL  + clientId + '/physical-seasons');
  }

  getPhysicalSeasonsOfClientWithProvider12(clientId) {
    return axios.get(API_URL  + clientId + '/physical-seasons-provider-12');
  }

  //Select ALL (Hub, Eventing, API, RAW EVENTING) leagues
  switchAllLeaguesOfClient(clientId, leagueIds, active, productId) {
    return axios.post(API_URL + 'switch-all-client-leagues',
      {
        clientId: clientId,
        leagueIds: leagueIds,
        active: active,
        productId: productId,
      }
    );
  }

  switchClientLeague(clientId, leagueId, isClientActive, area = null) {
    return axios.post(API_URL + 'switch-client-league',
      {
        client: clientId,
        league: leagueId,
        enable: isClientActive,
        area: area
      }
     );
  }

  switchClientLeagueHub(clientId, leagueId, isClientActiveHub, area = null) {
    return axios.post(API_URL + 'switch-client-league-hub',
      {
        client: clientId,
        league: leagueId,
        enable: isClientActiveHub,
        area: area
      }
    );
  }

  switchClientLeagueAPI(clientId, leagueId, isClientActiveAPI, area = null) {
    return axios.post(API_URL + 'switch-client-league-api',
      {
        client: clientId,
        league: leagueId,
        enable: isClientActiveAPI,
        area: area
      }
    );
  }

  switchClientLeagueRawEventing(clientId, leagueId, isClientActiveRawEventing, area = null) {
    return axios.post(API_URL + 'switch-client-league-raw-eventing',
      {
        client: clientId,
        league: leagueId,
        enable: isClientActiveRawEventing,
        area: area
      }
    );
  }

  switchSeasonOfClient(clientId, seasonId, state, productId) {
    return axios.post(API_URL + 'switch-client-season',
      {
        clientId: clientId,
        seasonId: seasonId,
        state: state,
        productId: productId
      }
    );
  }

  loadSeasonList() {
    return axios.get(`${API_URL}season-list`);
  }

  createSeasonList(seasonList) {
    return axios.post(`${API_URL}season-list`, seasonList);
  }

  updateSeasonList(seasonList) {
    return axios.put(`${API_URL}season-list/${seasonList.id}`,seasonList);
  }

  deleteSeasonList(seasonList) {
    return axios.delete(`${API_URL}season-list/${seasonList.id}`);
  }

  getClientById(clientId){
    return axios.get(API_URL + clientId);
  }

  getElementIdsWithVideo(){
    return axios.get(API_URL + "elements-with-video");
  }

  getGamesWithVideo(){
    return axios.get(API_URL + "games-with-video");
  }

  getGamesWithPD(){
    return axios.get(API_URL + "games-with-pd");
  }

  getActiveUsersOfClient(clientId) {
    return axios.get(API_URL + 'active-users/' + clientId);
  }

  getLastLoginOfActiveClients() {
    return axios.get(API_URL + 'last-login');
  }

  getClientAcademyTeams() {
    return axios.get(API_URL + 'academy-teams');
  }

  getCapture(clientId){
    return axios.get(`${API_URL}${clientId}/capture`);
  }

  getTotalRequestedGames(clientId){
    return axios.get(`${API_URL}${clientId}/requested`);
  }
  
  postClientTeamAcademy(clientId,teamId){
    return axios.post(`${API_URL}${clientId}/academy-team/${teamId}`);
  }

  getClientContracts(clientId){
    return axios.get(`${API_URL}${clientId}/contracts`);
  }

  getAllClientContracts(){
    return axios.get(`${API_URL}contracts`);
  }

  getAllClientTrials(){
    return axios.get(`${API_URL}trials`);
  }

  createClientContract(clientId, contract) {
    return axios.post(`${API_URL}${clientId}/contract`, contract);
  }

  updateClientContract(contract){
    return axios.put(`${API_URL}contract/${contract.id}`, contract);
  }

  deleteClientContract(contractId) {
    return axios.delete(`${API_URL}contract/${contractId}`, contractId);
  };

  getUserUpdates(clientId){
    return axios.get(`${API_URL}${clientId}/user-updates`);
  }

  postUserUpdate(update) {
    return axios.post(`${API_URL}${update.clientId}/user-update`, update);
  }
  
  updateNotesOfUserUpdate(update) {
    return axios.put(`${API_URL}user-update/${update.id}`, update);
  }

  getHasEventing() {
    return axios.get(`${API_URL}has-eventing`);
  }
  
}

export default new ClientService();



// WEBPACK FOOTER //
// ./src/services/client.service.js